/**
 * Check whether an avatar URL value is a renderable image source.
 * Returns true for http(s), data-URI, and blob URLs; false for
 * storage keys, null, undefined, or empty strings.
 */
export function isRenderableAvatar(
  value: string | null | undefined,
): value is string {
  if (!value) return false;
  return (
    value.startsWith("http://") ||
    value.startsWith("https://") ||
    value.startsWith("data:image/") ||
    value.startsWith("blob:")
  );
}
